export var CONTAINER_TEST_ID = 'product-features-list';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/ProductFeaturesList/constants.js
// module id = 4065
// module chunks = 11